import Customer         from "../../../domain/customer/Customer";
import Facility         from "../../../domain/facility/Facility";
import Date             from "../../../domain/fundamentals/date/Date";
import TimePeriod       from "../../../domain/fundamentals/date/TimePeriod";
import Reservation      from "../../../domain/reservation/Reservation";
import Staff            from "../../../domain/staff/Staff";
import ResKaReduxAction from "../ResKaReduxAction";

export enum ACTION_TYPE {
  SET_RESERVATION = "SET_RESERVATION",
  SET_RESERVATION_DATE = "SET_RESERVATION_DATE",
  SET_RESERVATION_TIME_PERIOD = "SET_RESERVATION_TIME_PERIOD",
  SET_RESERVATION_CUSTOMER = "SET_RESERVATION_CUSTOMER",
  SET_RESERVATION_STAFF = "SET_RESERVATION_STAFF",
  SET_RESERVATION_FACILITY = "SET_RESERVATION_FACILITY",
}

export interface SetReservationAction extends ResKaReduxAction {
  reservation: Reservation;
}

export interface SetReservationDateAction extends ResKaReduxAction {
  date: Date;
}

export interface SetReservationTimePeriodAction extends ResKaReduxAction {
  timePeriod: TimePeriod;
}

export interface SetReservationCustomerAction extends ResKaReduxAction {
  customer: Customer;
}

export interface SetReservationStaffAction extends ResKaReduxAction {
  staff: Staff;
}

export interface SetReservationFacilityAction extends ResKaReduxAction {
  facility: Facility;
}

export type ReservationAction =
  SetReservationAction
  | SetReservationDateAction
  | SetReservationTimePeriodAction
  | SetReservationCustomerAction
  | SetReservationStaffAction
  | SetReservationFacilityAction
  ;

export const setReservationAction = (reservation: Reservation): SetReservationAction => ({
  type: ACTION_TYPE.SET_RESERVATION,
  reservation: reservation,
});

export const setReservationDateAction = (date: Date): SetReservationDateAction => ({
  type: ACTION_TYPE.SET_RESERVATION_DATE,
  date: date,
});

export const setReservationTimePeriodAction = (timePeriod: TimePeriod): SetReservationTimePeriodAction => ({
  type: ACTION_TYPE.SET_RESERVATION_TIME_PERIOD,
  timePeriod: timePeriod,
});

export const setReservationCustomerAction = (customer: Customer): SetReservationCustomerAction => ({
  type: ACTION_TYPE.SET_RESERVATION_CUSTOMER,
  customer: customer,
});

export const setReservationStaffAction = (staff: Staff): SetReservationStaffAction => ({
  type: ACTION_TYPE.SET_RESERVATION_STAFF,
  staff: staff,
});

export const setReservationFacilityAction = (facility: Facility): SetReservationFacilityAction => ({
  type: ACTION_TYPE.SET_RESERVATION_FACILITY,
  facility: facility,
});